import { Box, Typography } from "@mui/material";
import {
  Root,
  Logo,
  Text,
  Point1,
  Point2,
  Point3,
} from "./Authentication.styles";

type Props = {
  error: { message: {title: string} };
};
const AuthenticationError: React.FC<Props> = (props: Props) => {
  return (
    <Root>
      <Logo />
      <Text variant="h5">
        <img
          src="/assets/images/savio-filoblu-small.gif"
          alt="savio-filoblu-small.gif"
        ></img>
        <Box>
          Ops<Point1>.</Point1>
          <Point2>.</Point2>
          <Point3>.</Point3>
          <br />
          {props?.error?.message?.title ?? "Unexpected error"}
        </Box>
      </Text>
    </Root>
  );
};

export default AuthenticationError;
